/** Plantilla editable de notificación (spec 13.2). */
export interface NotificationTemplate {
  id?: number;
  key: string;
  channel?: string;
  subject?: string;
  body?: string;
  variables?: string[] | string;
  updatedAt?: string;
  [key: string]: unknown;
}

/** Difusión push a una audiencia (spec 13.1). */
export interface PushBroadcast {
  title: string;
  body: string;
  audience: 'all' | 'sellers' | 'buyers';
}

/** App que recibe el push: cada una es un proyecto de Firebase. */
export type PushApp = 'buyers' | 'sellers';

/** Qué apps tienen credenciales de Firebase en el backend. */
export type PushConfigured = Record<PushApp, boolean>;

/** Sesión de un usuario con push registrado. */
export interface PushDevice {
  id: number;
  platform: 'ios' | 'android';
  deviceModel: string | null;
  appVersion: string | null;
  /** El usuario tiene activadas las notificaciones en ese teléfono. */
  pushEnabled: boolean;
  lastSeenAt: string;
  lastSentAt: string | null;
}

/** Usuario encontrado para la prueba push. */
export interface PushTestUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  app: PushApp | null;
  isActive: boolean;
  devices: PushDevice[];
}

export interface PushLookupResult {
  configured: PushConfigured;
  users: PushTestUser[];
}

/** Envío de prueba: `deviceId` vacío = a todas sus sesiones. */
export interface PushTestRequest {
  userId: number;
  deviceId?: number | null;
  title?: string;
  body?: string;
}

/** Lo que pasó con el envío de prueba. */
export interface PushTestResult {
  /** Dispositivos a los que se intentó enviar. */
  devices: number;
  sent: number;
  failed: number;
  /** Tokens que FCM rechazó y se dieron de baja. */
  invalidated: number;
  /** Dispositivos de una app sin credenciales de Firebase. */
  skipped: number;
  configured: PushConfigured;
}

/** Tipos de reporte exportables (spec 14.1). */
export type ReportType =
  | 'sales'
  | 'commissions'
  | 'taxes'
  | 'users'
  | 'refunds'
  | 'returns'
  | 'products';

export const REPORT_TYPES: { type: ReportType; label: string; description: string; icon: string }[] = [
  { type: 'sales', label: 'Ventas', description: 'Pagos y ventas por periodo', icon: 'banknote' },
  { type: 'commissions', label: 'Comisiones', description: 'Apartado PLATFORM del ledger', icon: 'bank' },
  { type: 'taxes', label: 'Impuestos', description: 'Apartado TAX del ledger', icon: 'receipt' },
  { type: 'users', label: 'Usuarios', description: 'Altas y actividad de usuarios', icon: 'users' },
  { type: 'refunds', label: 'Reembolsos', description: 'Reembolsos totales y parciales', icon: 'undo' },
  { type: 'returns', label: 'Devoluciones', description: 'Devoluciones y resoluciones', icon: 'package' },
  { type: 'products', label: 'Productos', description: 'Publicaciones y más vendidas', icon: 'bolt' },
];
